/** Shared accent colors for automation / sparkle UI across dashboard and meals workflow. */
export const AUTOMATION_ACCENT = "#7c9eff";
